<template>
  <FormulateForm v-model="formValues">
    <b-row>
      <b-col md="4" v-for="(field, idx) in fields" :key="idx" class="border">
        <div>
          <FormulateInput v-bind="field" />
          <div>
            <pre>{{ JSON.stringify({ value: formValues[field.name] }, null, 2) }}</pre>
          </div>
        </div>
      </b-col>
    </b-row>
  </FormulateForm>
</template>

<script>
export default {
  data() {
    return {
      formValues: {},

      fields: [
        {
          type: 'switch',
          label: 'With Default Value',
          value: true,
          name: 'default',
        },
        {
          type: 'switch',
          label: 'With Custom Value',
          valueTrue: 'ACTIVE',
          valueFalse: 'INACTIVE',
          name: 'custom-value',
        },
        {
          type: 'switch',
          label: 'With Custom Value from Function',
          valueTrue: () => 'ACTIVE from function',
          valueFalse: () => 'INACTIVE from function',
          name: 'custom-value-function',
        },
        {
          type: 'switch',
          label: 'Value Label Right (default)',
          name: 'value-label-right',
        },
        {
          type: 'switch',
          label: 'Value Label Left',
          name: 'value-label-left',
          valueLabelPosition: 'left',
        },
        {
          type: 'switch',
          label: 'With Custom Value Label',
          name: 'custom-value-label',
          valueLabelTrue: 'Custom Active',
          valueLabelFalse: 'Custom Inactive',
        },
      ],
    }
  },
}
</script>
